import antdMessage                  from 'antd/lib/message';
import { MessageInstance }          from 'antd/lib/message/interface';
import React                        from 'react';
import getTextAndTranslateFromError from '@widesk-core/tools/getTextAndTranslateFromError';
import { hasErrorTranslation }      from '@widesk-core/tools/getTextAndTranslateFromError';
import { getErrorRequest }          from '@widesk-core/tools/requestError';
import { getErrorStatus }           from '@widesk-core/tools/requestError';
import { ArgsProps }                from 'antd/lib/message/interface';
import RequestErrorMessage          from '@widesk-ui/components/RequestErrorMessage';

let _message: MessageInstance;

const REQUEST_ERROR_TEXTS: Record<number, string> = {
	403: 'Vous n\'avez pas les autorisations pour effectuer cette action.',
	404: 'L\'élément demandé est introuvable, ou vous n\'avez pas les droits pour le consulter.',
};

export const open = (config: ArgsProps) => getMessage()?.open(config);
export const info = (content: React.ReactNode, duration = 4) => getMessage()?.info(content, duration);
export const success = (content: React.ReactNode, duration = 4) => getMessage()?.success(content, duration);
export const error = (content: React.ReactNode, duration = 4) => getMessage()?.error(content, duration);
export const exceptionArgs = (error: any, duration = 4): ArgsProps => {
	const status = getErrorStatus(error);
	const text = status ? REQUEST_ERROR_TEXTS[status] : undefined;

	if (text && !hasErrorTranslation(error)) {
		const request = getErrorRequest(error);

		return {
			type: 'error',
			key: `${status} ${request}`,
			content: React.createElement(RequestErrorMessage, { text, request }),
			duration,
		};
	}

	return { type: 'error', content: getTextAndTranslateFromError(error), duration };
};

export const exception = (error: any, duration = 4) => {
	console.error(error);
	return getMessage()?.open(exceptionArgs(error, duration));
};
export const warning = (content: React.ReactNode, duration = 4) => getMessage()?.warning(content, duration);

export default function useMessage() {
	const [messageApi, contextHolder] = antdMessage.useMessage({ top: 60 });

	_message = messageApi;

	return [contextHolder];
}

const getMessage = () => {
	if (_message) return _message;
	console.error(`L'instance de message n'a pas encore été initialisée.`);
};

export const message = { success, error, exception, warning, info, open };
